import { MapContainer, TileLayer, Circle, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

const icon = L.icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});

const areas = [
  { name: "Kuala Lumpur", pos: [3.139, 101.6869] },
  { name: "Petaling Jaya", pos: [3.1073, 101.6067] },
  { name: "Shah Alam", pos: [3.0738, 101.5183] },
  { name: "Klang", pos: [3.0449, 101.4456] },
  { name: "Subang Jaya", pos: [3.0567, 101.5851] },
  { name: "Ampang", pos: [3.15, 101.76] },
  { name: "Cheras", pos: [3.0631, 101.7481] },
  { name: "Putrajaya", pos: [2.9264, 101.6964] },
];

export const ServiceAreaMap = () => (
  <div data-testid="service-area-map" className="rounded-2xl overflow-hidden border border-slate-200 shadow-sm">
    <MapContainer center={[3.08, 101.6]} zoom={10} scrollWheelZoom={false} style={{ height: "420px", width: "100%" }}>
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Circle center={[3.08, 101.6]} radius={30000} pathOptions={{ color: "#10B981", fillColor: "#10B981", fillOpacity: 0.12 }} />
      {areas.map((a) => (
        <Marker key={a.name} position={a.pos} icon={icon}>
          <Popup>{a.name}</Popup>
        </Marker>
      ))}
    </MapContainer>
  </div>
);
